import { useMemo } from 'react';
import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/settings/v2/settings.pb';
import { useQueries } from 'react-query';
import { ScheduleApi } from '@frontend/api-schedule';
import { HttpError } from '@frontend/fetch';
import { getArrayWithNonEmptyValues } from '@frontend/payments-hooks';

export const useGetProviders = (locationId: string | undefined | string[]) => {
  const locationIds = getArrayWithNonEmptyValues(locationId);
  const providersResult = useQueries(
    locationIds.map((locationId) => ({
      queryKey: ['providers', locationId],
      queryFn: () => ScheduleApi.listProviders({ locationId }),
      enabled: !!locationId,
      retry: 1,
    }))
  );

  const { providers, isLoading, isFetched, error } = useMemo(
    () =>
      providersResult.reduce(
        (acc, result) => {
          const { data, isLoading, isFetched, error } = result;

          acc.providers.push(...(data?.providers ?? []));
          acc.isLoading = acc.isLoading || isLoading;
          acc.isFetched = acc.isFetched || isFetched;
          if (error instanceof HttpError) acc.error = acc.error || (error as HttpError);

          return acc;
        },
        {
          providers: [] as Provider[],
          isLoading: false,
          isFetched: false,
          error: undefined as HttpError | undefined,
        }
      ),
    [providersResult]
  );

  return { providers, isLoading, isFetched, error };
};
